export default __webpack_public_path__ + "static/media/58.4893b6ad.gif";